import http from "../../http";

/** 用户房屋绑定（管理） — /resident/api/resident/houseUserBind */
const BASE = "/resident/api/resident/houseUserBind";

const userBind = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  detail(r) {
    return http.get(`${BASE}/detail`, r);
  },
  adminConfirm(r) {
    return http.payload(`${BASE}/adminConfirm`, r);
  },
  adminApprove(r) {
    return http.payload(`${BASE}/adminApprove`, r);
  },
  adminReject(r) {
    return http.payload(`${BASE}/adminReject`, r);
  },
  adminUnbind(r) {
    return http.payload(`${BASE}/adminUnbind`, r);
  },
};

export default userBind;
